export const environment = {
  production: false,
  // meepServerUrl: 'http://localhost/Promptus.Meep.Server',
  // meepServerUrl: 'http://10.190.190.191/Promptus.Meep.Server',
  meepServerUrl: 'https://portal-api-dev.meep.cloud',
  blobUrl: 'https://meepblobdev.blob.core.windows.net/usuarios-profile',
  customBlobUrl: 'https://meepcustomblobdev.blob.core.windows.net'
};



// WEBPACK FOOTER //
// /usr/src/app/src/environments/environment.ts